import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spacing(1.5)};
`;

export const CustomAccordion = styled(Accordion)`
  width: 100%;
  background: ${(p) => p.theme.palette.common.white};
  .MuiAccordion-root {
    gap: 0 !important;
  }

  &.Mui-expanded {
    box-shadow: none;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
  }
  .MuiPaper-root {
    gap: 0;
  }
`;
export const CustomSummary = styled(AccordionSummary)`
  padding: ${(p) => p.theme.spacing(0.5, 1)};
  min-height: 0 !important;
  color: ${(p) => p.theme.palette.grey[300]};
  font-size: ${(p) => p.theme.typography.body3.fontSize};
  flex-shrink: 0;

  & .MuiAccordionSummary-content {
    margin: 0 !important;
    overflow: hidden !important;
    height: ${(p) => p.theme.spacing(3)} !important;
  }

  & .MuiAccordionSummary-expandIconWrapper {
    margin-left: 0 !important;
  }
`;

export const DetailWrapper = styled(AccordionDetails)`
  padding: ${(p) => p.theme.spacing(0.5, 1, 1, 1)} !important;
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spacing(1)};
`;
